// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__Ma-0s","wrapper":"Contact_wrapper__G8O7X","mail":"Contact_mail__ZxUCk","icons":"Contact_icons__fSeKK"};